import Axios from 'axios'

Axios.defaults.baseURL = "https://shopping.test/api/"
Axios.defaults.headers.common['Accept'] = 'application/json'


Axios.interceptors.request.use((config) => {
    let token = localStorage.getItem('user-token')

    if (token) config.headers['Authorization'] = `Bearer ${token}`

    return config
},
    (error) => {
        console.log('error.status')
        if (error.response.status === 401) {
            console.log(error.status)
        }

        return Promise.reject(error)
    }
)

export default {
    // start auth
    AUTH_REQUEST: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            commit('AUTH_REQUEST')
            Axios.post('/login', data)
                .then(resp => {
                    const token = resp.data.data.access_token
                    localStorage.setItem('user-token', token)

                    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

                    commit('AUTH_SUCCESS', token)
                    resolve(resp)
                })
                .catch(err => {
                    commit('AUTH_ERROR', err)
                    localStorage.removeItem('user-token')
                    delete Axios.defaults.headers.common['Authorization']
                    reject(err)
                })
        })
    },
    AUTH_LOGOUT: ({ commit }) => {
        return new Promise((resolve, reject) => {
            Axios.post(`/logout`).then(function () {
                commit('AUTH_LOGOUT')
                localStorage.removeItem('user-token')
                delete Axios.defaults.headers.common['Authorization']
                resolve()
            })
                .catch(function () {
                    reject()
                })
        })
    },
    // end auth

    // start store
    GET_STORES: ({ commit }) => {
        return new Promise((resolve, reject) => {
            Axios.get(`/stores?group-by=parent_id`).then(function (response) {
                commit('SET_STORES', response.data.data)
                resolve()
            })
            .catch(() => { reject()})
        })
    },
    SAVE_STORE_ID : ({ commit }, storeId) => {
        return new Promise((resolve) => {
            commit('SET_STORE_ID', storeId)
            localStorage.setItem('last-store-id', storeId)
            resolve()
        })
    },
    GET_STORE: ({ state, commit }) => {
        Axios.get(`/stores/${state.storeId}`).then(function (response) {
            commit('SET_STORE', response.data.data)
        })
        .catch(() => { })
    },
    GET_STORE_DATA : ({ commit, state}) => {
        Axios.get(`stores/${state.storeId}/categories`).then(function (response) {
            commit('SET_STORE_CATEGORIES', response.data.data)
        })
        .catch(function () { })
    },
    // end store

    // start categories
    GET_CATEGORY_PRODUCTS: ({ commit, state }) => {
        Axios.get(`stores/${state.storeId}/categories/${state.categoryId}/products`).then(function (response) {
            commit('SET_PRODUCTS', response.data.data)
        })
            .catch(function () { })
    },
    // end categories

    // start user
    GET_USER: ({ commit }) => {
        Axios.get(`/user`).then(function (response) {
            commit('SET_USER', response.data.data.user)
        })
        .catch((error) => {
            if (error.response.status === 401) {
                commit('AUTH_LOGOUT')
                localStorage.removeItem('user-token')
                delete Axios.defaults.headers.common['Authorization']
                this.$router.push('/login')
            }
        })
    },
    GET_USER_CART: ({ state, commit }) => {
        Axios.get(`user/${state.user.id}/store/${state.storeId}/cart`).then(function (response) {
            commit('SET_CART', response.data.data)
        }).catch(() => { })
    },
    GET_USER_ORDERS: ({ state, commit }) => {
        Axios.get(`user/${state.user.id}/store/${state.storeId}/orders`).then(function (response) {
            commit('SET_ORDERS', response.data.data)
        }).catch(() => { })
    },
    // end user

    // start cart
    ADD_PRODUCT_TO_CART: ({ state, commit, dispatch }, product) => {
        if (product.pivot.inventory > 0) {
            var item = {}
            var cartItem = state.cartProducts.find(item => item.id === product.id)
            
            if (!cartItem) {
                commit('PUSH_PRODUCT_TO_CART', product)
                item = {"product_id": product.id, "quantity": 1}
            } else {
                commit('INCREMENT_CART_ITEM_QNT', cartItem)
                console.log(cartItem)
                item = {"product_id": cartItem.id, "quantity": cartItem.pivot.quantity}
            }
            commit('DECREMENT_PRODUCT_INVENTORY', product)   
            dispatch('UPDATE_CART_IN_DB', item)
        }
    },
    UPDATE_CART_IN_DB: ({ state }, data) => {
        console.log(data)
        Axios.put(`/carts/${state.cartId}`, data).
        catch((error) => {
            console.log(error.response)
        })
    },
    REMOVE_PRODUCTS_FROM_CART: ({ state, commit }, productIds) => {
        return new Promise((resolve, reject) => {
            Axios.delete(`/carts/${state.cartId}`, {'data': {'products_ids': productIds}}).then(function (response) {
                commit('SET_CART', response.data.data)
                resolve()
            })
            .catch(() => {
                reject()
            })
        })
    },
    EMPTY_CART: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            Axios.delete(`/carts/${state.cartId}`).then(function (response) {
                commit('SET_CART', response.data.data)
                resolve()
            })
            .catch(() => {
                reject()
            })
        })
    },
    CART_HAS_PRODUCT_IN_QUANTITY: ({state}, productId, quantity) => {
        var product = state.cartProducts.filter((product) => {
            return product.id === productId && product.pivot.quantity === quantity
        })

        if(product) return true

        return false
    },
    // end cart

    // start checkout
    CHECKOUT: ({ state }) => {
        return new Promise((resolve, reject) => {
            Axios.post(`/carts/${state.cartId}/checkout`).then(function () {
                resolve()
            })
            .catch(() => {
                reject()
            })
        })
    },
    PROCESS_PAYMENT: ({ commit, state }, data) => {
        return new Promise((resolve, reject) => {
            Axios.post(`/carts/${state.cartId}/pay`, data).then(function (response) {
                commit('EMPTY_CART')
                resolve(response.data.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    // end checkout

    // start orders
    SAVE_CURRENT_ORDER: ({commit}, order) => {
        commit('SET_CURRENT_ORDER', order)
    },
    RESET_CURRENT_ORDER: ({commit}) => {
        commit('RESET_CURRENT_ORDER')
    },
    UPDATE_ORDERS: ({commit}, order) => {
        commit('UPDATE_ORDERS', order)
    },
    // end orders

    // start notifications
    SUBSCRIBE_TO_EVENTS: ({state, dispatch}) => {
        state.orders.map((order) => {
            if(!order.processed) {
                window.Echo.private(`order.${order.id}`)
                .listen(`order.processed`, order => {
                    dispatch('DISPLAY_NOTIFICATION', 'Order processed, awaiting collection', `Order ${order.id} ready for collection`, `${window.location.origin}/orders`)
                    console.log(order)
                })
            }

            if(!order.fulfilled) {
                window.Echo.private(`order.${order.id}`)
                .listen(`order.fulfilled`, order => {
                    dispatch('DISPLAY_NOTIFICATION', `You have collected order ${order.id}. Thank you for shopping with ${order.store.name}. Please come again.`, `${window.location.origin}/orders`)
                    console.log(order)
                })
            }
        })
    },
    DISPLAY_NOTIFICATION: (state, title, body, destPage) => {
        if (! ('Notification' in window)) {
            alert('Web Notification is not supported');
            return;
        }
        Notification.requestPermission( () => {
            new Notification(title, {
                body: body, // content for the alert
                icon: "https://via.placeholder.com/320x320" // optional image url
            }).onclick = () => {
                window.open(destPage);
            };
        });
    }
    // end notifications
}